<template>
  <div>
    <div class="text-muted text-center">Ganancias Pagadas</div>
    <div style="height: 335px">
      <CChartBar :datasets="defaultDatasets" :labels="labels" class="mt-4" v-if="data.length > 0 && !isLoading" />
      <div v-if="data.length == 0 && !isLoading" class="text-center mt-4">
        <p>Sin datos para mostrar</p>
      </div>
      <div v-if="isLoading" class="text-center mt-4">
        <div class="spinner-border text-primary">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CChartBar } from "@coreui/vue-chartjs";
import Resource from "@/api/resource";

const resource = new Resource("dashboard");

export default {
  name: "ProfitPaid",
  components: {
    CChartBar,
  },
  data() {
    return {
      isLoading: false,
      data: [],
    };
  },
  computed: {
    defaultDatasets() {
      return [{
        label: 'Total',
        backgroundColor: 'rgb(8,125,233,0.5)',
        data: this.data.map(item => this.formatPrice(item.total)),
      }];
    },
    labels() {
      return this.data.map(item => item.month);
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const result = await resource.get("profitPaid?tree=1");
        if (result.status == 200) {
          this.data = result.data;
        } else {
          console.log(result);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    formatPrice(value) {
      return Math.round(value * 100) / 100
    },
  },
};
</script>
